import {SupportCase, useSupportCaseStore} from '../../store/supportCaseStore';
import {useEffect, useState} from 'react';

type CaseProviderProps = {
    children: (supportCase: SupportCase, reset: () => void) => JSX.Element;
    bearer: null | string;
};

const SupportCaseProvider = ({children, bearer}: CaseProviderProps) => {
    const supportCase = useSupportCaseStore(state => state.supportCase);
    const createSupportCase = useSupportCaseStore(
        state => state.createSupportCase
    );
    const reset = useSupportCaseStore(state => state.reset);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading || null === bearer || null !== supportCase) {
            return;
        }

        setLoading(true);

        const abortController = new AbortController();
        createSupportCase(bearer, abortController)
            .then(() => {})
            .finally(() => {
                setLoading(false);
            });

        return () => {
            setLoading(false);
            abortController.abort();
        };
    }, [bearer, supportCase, createSupportCase, loading, setLoading]);

    if (supportCase !== null) {
        return <>{children(supportCase, reset)}</>;
    }

    return <div>Loading...</div>;
};

export default SupportCaseProvider;
